module.exports = __webpack_public_path__ + "static/media/second_1.943dde18.jpg";